module.exports = __webpack_public_path__ + "static/media/5-environment.9b01afc8.svg";